import React from "react";

const DashboardHeader = () => {
  return (
    <div className="flex flex-col flex-shrink-0">
      <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
      <p className="text-muted-foreground mt-1">Monitoree sus gastos y pagos de servicios</p>
    </div>
  );
};

export default DashboardHeader;